import { CardContent, Typography, Box } from '@mui/material';
import { ClearingInfo, TriggerInfo } from 'src/types/alarms';
import { AlarmCommunicationItem } from '../alarmCommunicationItem';
import { AlarmPopupCard } from '../style';

import {
  LiveDataAlarmClearingInfo,
  LiveDataAlarmTriggerInfo,
} from '../liveDataAlarmConditionSection';

type Props = {
  triggerInfo?: TriggerInfo;
  clearingInfo?: ClearingInfo;
  type: 'LiveDataAlarm' | 'CommunicationAlarm';
};

export const ConditionsBox = ({ triggerInfo, clearingInfo, type }: Props) => {
  const isClearCondition = (clearingInfo?.clearingConditions?.length ?? 0) > 0 || clearingInfo;
  const isTriggerCondition = (triggerInfo?.triggerConditions?.length ?? 0) > 0;
  const isCommunicationAlarm = type === 'CommunicationAlarm';

  return (
    <AlarmPopupCard>
      <CardContent sx={{ padding: '16px' }}>
        <Typography variant="h6">Conditions:</Typography>

        <Box sx={{ marginTop: '3px' }}>
          {isCommunicationAlarm && triggerInfo && (
            <AlarmCommunicationItem
              title="Trigger info"
              checkedAt={triggerInfo?.checkedAt}
              payloadInterval={triggerInfo?.payloadInterval}
              lastPayloadReceived={triggerInfo?.lastPayloadReceived}
              conditions={triggerInfo?.triggerConditions}
            />
          )}
          {isCommunicationAlarm && clearingInfo && (
            <AlarmCommunicationItem
              title="Clearing info"
              payloadInterval={clearingInfo?.clearingDelay}
              lastPayloadReceived={clearingInfo?.lastPayloadReceived}
              conditions={clearingInfo?.clearingConditions}
              checkedAt={clearingInfo?.checkedAt}
            />
          )}
          {isTriggerCondition && triggerInfo && (
            <LiveDataAlarmTriggerInfo testId="trigger-conditions" triggerInfo={triggerInfo} />
          )}
          {isClearCondition && !isCommunicationAlarm && clearingInfo && (
            <LiveDataAlarmClearingInfo testId="clear-conditions" clearingInfo={clearingInfo} />
          )}
        </Box>
      </CardContent>
    </AlarmPopupCard>
  );
};
